import {
  LYSCol,
  LYSDivider,
  LYSRow,
  LYSTypography,
} from '@core/components/Primitives'
import Link from 'next/link'
import { useTranslation } from '@core/i18n/i18n'
import { useProductDetailContext } from '@core/utils/models/product/ProductContext'
import routes from '@core/config/routes'
import style from './index.module.less'
import React from 'react'

interface Props {
  className: string
  withBottomDivider?: boolean
}

const Awards: React.FC<Props> = ({ className, withBottomDivider }) => {
  const { t } = useTranslation()
  const { product } = useProductDetailContext() || {}

  if (!product || product.awards.length === 0) {
    return null
  }

  const { awards } = product

  const getAwardRoute = (awardId: string) => routes.awardDetail(awardId)

  return (
    <LYSRow align="middle" className={className}>
      <LYSCol xs={24}>
        <LYSTypography.Title level={4}>
          {t('productDetail.awards')}
        </LYSTypography.Title>
      </LYSCol>
      <LYSCol xs={24}>
        <LYSRow align="middle" justify="start">
          {awards.map((award) => (
            <LYSCol key={award.label}>
              <Link {...getAwardRoute(award.id)}>
                <img
                  src={award.image}
                  className={style.awardImage}
                  alt={award.label}
                  title={award.label}
                  loading="lazy"
                  width={50}
                  height={50}
                />
              </Link>
            </LYSCol>
          ))}
        </LYSRow>
        {withBottomDivider && <LYSDivider />}
      </LYSCol>
    </LYSRow>
  )
}

export default Awards
